import { render } from "./NewsListView.vue?vue&type=template&id=5641e778"
import script from "./NewsListView.vue?vue&type=script&lang=js"
export * from "./NewsListView.vue?vue&type=script&lang=js"

import "./NewsListView.vue?vue&type=style&index=0&id=5641e778&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__